import React from "react";
import DashboardMapFilter from "./DashboardMapFilter";

export default function FleetMapView({ filterBy = "vehicles", emptyLabel = "All Routes" }) {
  return (
    <div className="reusable-fleet-map">
      <DashboardMapFilter
        filterBy={filterBy}
        compact
        headerTitle="Live Fleet View"
        emptyLabel={emptyLabel}
        showExpandButton
      />
    </div>
  );
}
